import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'entityId', null)

    return {
        data: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'dotace', 'customData', 'data']),
        pagination: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'dotace', 'customData', 'pagination']),
        sorted: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'dotace', 'customData', 'sorted']),
        isLoading: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'dotace', 'customData', 'isLoading']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
